import * as React from 'react';

import {Box, Typography} from '@mui/material';
import PayrollTabs, {type PayrollTabKey} from '../../../components/Payroll/PayrollTabs';
import {PayrollTabContext} from '../../../components/Payroll/PayrollTabContext';
import PayrollWorkflowSteps from '../../../components/Payroll/PayrollWorkflowSteps';
import {useTranslation} from 'react-i18next';

interface PayrollPageProps {
    /** Tab to open first (used by the legacy "Work Evidence" route, which now maps to a Payroll tab). */
    readonly initialTab?: PayrollTabKey;
}

export default function PayrollPage({initialTab}: Readonly<PayrollPageProps>): React.JSX.Element {
    const {t} = useTranslation();
    const [tab, setTab] = React.useState<PayrollTabKey | undefined>(initialTab);
    const tabContext = React.useMemo(() => ({selectTab: setTab}), []);

    return (
        <PayrollTabContext.Provider value={tabContext}>
            <Box sx={{textAlign: 'left', mb: 1}}>
                <Typography variant="h5" sx={{fontWeight: 700}}>
                    {t('payroll.page.title')}
                </Typography>
                <Typography variant="body1" sx={{color: 'text.secondary'}}>
                    {t('payroll.page.subtitle')}
                </Typography>
            </Box>
            <PayrollTabs
                selectedTab={tab}
                onTabChange={setTab}
                belowTabs={<PayrollWorkflowSteps onViewSteps={() => setTab('workEvidence')}/>}
            />
        </PayrollTabContext.Provider>
    );
}
